<template>
  <div>
    <el-form label-position="left" label-width="120px" size="small" :model="form">
      <el-form-item class="w500" label="管理员名称">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item class="w500" label="手机">
        <el-input v-model="form.mobile"></el-input>
      </el-form-item>
      <el-form-item class="w500" label="账号">
        <el-input v-model="form.account"></el-input>
      </el-form-item>
      <el-form-item class="w500" label="密码">
        <el-input v-model="form.password" type="password"></el-input>
      </el-form-item>
      <el-form-item class="w500" label="确认密码">
        <el-input v-model="form.password1" type="password"></el-input>
      </el-form-item>
      <el-form-item class="w500" label="角色权限">
        <el-select v-model="form.group_id" placeholder="请选择">
          <el-option v-for="(value, name) in groupList" :key="name" :label="value.title" :value="value.id"> </el-option>
        </el-select>
      </el-form-item>
      <!--            <el-form-item label="数据权限">
                <div>
                    <el-button @click="addStage">新增阶段</el-button>
                    <span>
                        &nbsp;&nbsp;&nbsp;可选择该管理员登录后台后可查看勾选分组、标签下的用户列表、打卡列表信息）</span>
                </div>

                <div v-if="form.admin_relation_vo">
                    <div
                        v-for="item in form.admin_relation_vo"
                        :key="item.admin_relation_stage"
                        class="stage"
                    >
                        <el-button
                            type="text"
                            class="delete"
                            @click="deleteStage(item.admin_relation_stage)"
                        >删除</el-button>
                        <div class="stage-title">
                            {{ item.stage_name }}
                        </div>
                        <div class="stage-group">
                            <span>分组 </span>
                            <el-checkbox-group
                                v-model="
                                    checkGroupList[item.admin_relation_stage]
                                "
                            >
                                <el-checkbox
                                    v-for="group in item.admin_relation_grouping"
                                    :key="group.uuid"
                                    :label="group.uuid"
                                >{{ group.grouping_name }}</el-checkbox>
                            </el-checkbox-group>
                        </div>
                        <div class="stage-tag">
                            <span>标签</span>
                            <div>
                                <el-checkbox-group
                                    v-model="
                                        checkTagList[item.admin_relation_stage]
                                    "
                                >
                                    <el-checkbox
                                        v-for="tag in item.admin_relation_label"
                                        :key="tag.uuid"
                                        :label="tag.uuid"
                                    >{{ tag.label_name }}</el-checkbox>
                                </el-checkbox-group>
                            </div>
                        </div>
                    </div>
                </div>
            </el-form-item> -->

      <!--  <el-form-item label="关联用户信息">
                <div>
                    <el-button @click="relationUser">关联用户</el-button>
                </div>
                <div v-if="!userList.length">
                    <span class="empty">暂无</span>
                </div>
                <div v-else class="table">
                    <el-table :data="currentList">
                        <el-table-column
                            property="user_name"
                            label="昵称"
                        ></el-table-column>
                        <el-table-column
                            property="user_mobile"
                            label="手机"
                        ></el-table-column>
                        <el-table-column
                            width="200"
                            property="address"
                            label="地址"
                        >
                            <template slot-scope="scope">
                                <span>{{ scope.row.province }}{{ scope.row.city
                                }}{{ scope.row.area }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            property="fans_num"
                            label="用户粉丝数量"
                        ></el-table-column>
                        <el-table-column
                            property="punch_day_num"
                            label="用户打卡天数"
                        ></el-table-column>
                        <el-table-column
                            property="like_num"
                            label="用户点赞数量"
                        ></el-table-column>
                        <el-table-column
                            property="create_time"
                            label="注册时间"
                        ></el-table-column>
                        <el-table-column label="操作" width="150">
                            <template slot-scope="scope">
                                <el-button
                                    type="text"
                                    size="small"
                                    @click="handleDeleteClick(scope.row.uuid)"
                                >删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="page">
                        <pagination
                            v-show="total > 0"
                            :page-sizes="[10]"
                            :total="total"
                            :auto-scroll="false"
                            :page.sync="listQuery.page_index"
                            :limit.sync="listQuery.page_size"
                            @pagination="getTableList"
                        />
                    </div>
                </div>
            </el-form-item> -->
    </el-form>
    <div class="footer">
      <el-button type="primary" @click="formSubmit">提交</el-button>
    </div>
    <el-dialog title="选择阶段" :show-close="false" :close-on-click-modal="false" :visible.sync="dialogStageVisible">
      <el-table ref="multipleTable" :data="stageList" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"> </el-table-column>

        <el-table-column property="stage_level" label="阶段等级"></el-table-column>
        <el-table-column property="stage_name" label="阶段名称"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onCloseStage">取 消</el-button>
        <el-button type="primary" @click="onOKStage">确 定</el-button>
      </div>
    </el-dialog>
    <UserSelector
      :visible="dialogRelationVisible"
      :selected-list="userList"
      @onOk="setUser"
      @onCancel="dialogRelationVisible = false"
    ></UserSelector>
  </div>
</template>
<script>
import { getAdminAuthGroupSelect, editAdmin, getAdminDetail } from "@/api/auth";
import { getStageList, getTagList, getGroupList } from "@/api/stage";
import UserSelector from "./component/UserSelector";
import Pagination from "@/components/Pagination";
export default {
  components: { UserSelector, Pagination },
  data() {
    return {
      form: {
        name: "",
        mobile: "",
        account: "",
        password: "",
        password1: "",
        group_id: "",
        admin_relation_vo: [],
      },
      groupList: [],
      stageList: [],
      dialogStageVisible: false,
      selectedStage: "",
      black: "",
      checkTagList: {},
      checkGroupList: {},
      dialogRelationVisible: false,
      userList: [],
      oldPassWord: "",
      total: 0,
      listQuery: {
        page_index: 1,
        page_size: 10,
      },
      currentList: [],
    };
  },
  watch: {
    userList: function name(val) {
      this.total = val.length;
      this.$nextTick(() => {
        this.getTableList();
      });
    },
  },
  async mounted() {
    const list = await getAdminAuthGroupSelect();
    this.groupList = list;
    const { uuid } = this.$route.query;
    const res = await getAdminDetail(uuid);
    // const admin_relation_vo = [];
    // res.admin_relation_vo.map(async i => {
    //     const tags = i.admin_relation_label_vo.map(i => i.uuid);
    //     const groups = i.admin_relation_grouping_vo.map(i => i.uuid);
    //     this.$set(this.checkTagList, i.admin_relation_stage, tags);
    //     this.$set(this.checkGroupList, i.admin_relation_stage, groups);
    //     const admin_relation_label = await getTagList({
    //         data_type: 2,
    //         stage_uuid: i.admin_relation_stage
    //     });
    //     const admin_relation_grouping = await getGroupList({
    //         data_type: 2,
    //         stage_uuid: i.admin_relation_stage
    //     });
    //     admin_relation_vo.push({
    //         stage_name: i.admin_relation_stage_name,
    //         admin_relation_stage: i.admin_relation_stage,
    //         admin_relation_label,
    //         admin_relation_grouping
    //     });
    // });

    this.form = {
      name: res.name,
      mobile: res.mobile,
      account: res.account,
      password: res.password,
      password1: res.password,
      group_id: res.group_id,
      // admin_relation_vo
    };
    this.oldPassWord = res.password;
    this.userList = res.admin_relation_user_vo;
    this.$nextTick(() => {
      this.getTableList();
    });
  },
  methods: {
    getTableList(params = this.listQuery) {
      const { page_index, page_size } = params;
      const start = (page_index - 1) * page_size;
      const end = page_index * page_size;
      this.currentList = this.userList.slice(start, end);
    },
    setCheckBox() {},
    async formSubmit() {
      const { name, mobile, account, password, password1, group_id, admin_relation_vo } = this.form;

      if (password !== password1) {
        return this.$notify({ title: "密码不一致", type: "error" });
      }
      const { uuid } = this.$route.query;

      const checkGroupList = this.checkGroupList;
      const checkTagList = this.checkTagList;
      const params = {
        name,
        mobile,
        account,
        password,
        group_id,
        admin_relation_vo: [],
      };
      if (this.oldPassWord === password) delete params.password;
      admin_relation_vo.forEach((item) => {
        params.admin_relation_vo.push({
          admin_relation_stage: item.admin_relation_stage,
          admin_relation_label: checkTagList[item.admin_relation_stage] || [],
          admin_relation_grouping: checkGroupList[item.admin_relation_stage] || [],
        });
      });
      params.admin_relation_user_arr = this.userList.map((i) => i.uuid);
      await editAdmin(uuid, params);
      this.$notify({ title: "操作成功", type: "success" });
      this.$router.push({ path: "/admin-list" });
    },
    relationUser() {
      this.dialogRelationVisible = true;
    },
    async addStage() {
      const list = await getStageList({ data_type: 2 });
      this.stageList = list.filter((i) => {
        const result = this.form.admin_relation_vo.findIndex((j) => j.admin_relation_stage === i.uuid);
        return result < 0;
      });
      this.dialogStageVisible = true;
    },
    stagechange(row) {
      this.selectedStage = row;
    },
    handleSelectionChange(val) {
      this.selectedStage = val;
    },
    onCloseStage() {
      this.dialogStageVisible = false;
      this.selectedStage = [];
      this.$refs.multipleTable.clearSelection();
      this.black = "";
    },
    async onOKStage() {
      for (let index = 0; index < this.selectedStage.length; index++) {
        const { uuid, stage_name } = this.selectedStage[index];
        const admin_relation_label = await getTagList({
          data_type: 2,
          stage_uuid: uuid,
        });
        const admin_relation_grouping = await getGroupList({
          data_type: 2,
          stage_uuid: uuid,
        });
        this.form.admin_relation_vo.push({
          stage_name,
          admin_relation_stage: uuid,
          admin_relation_label,
          admin_relation_grouping,
        });
        this.$set(this.checkTagList, uuid, []);
        this.$set(this.checkGroupList, uuid, []);
      }
      this.onCloseStage();
    },
    deleteStage(stageId) {
      const list = this.form.admin_relation_vo.filter((i) => i.admin_relation_stage !== stageId);
      this.form.admin_relation_vo = list;
      const checkTagList = this.checkTagList;
      delete checkTagList[stageId];
      this.checkTagList = checkTagList;

      const checkGroupList = this.checkGroupList;
      delete checkGroupList[stageId];
      this.checkGroupList = checkGroupList;
    },
    setUser(val) {
      this.listQuery.page_index = 1;
      this.userList = val;
      this.$nextTick(() => {
        this.getTableList();
      });

      this.$notify({ title: "关联成功", type: "success" });
    },
    handleDeleteClick(uuid) {
      this.userList = this.userList.filter((i) => i.uuid !== uuid);
    },
  },
};
</script>
<style lang="less" scoped>
.w500 {
  width: 500px;
}
.stage {
  border: 1px dashed #999;
  border-radius: 5px;
  width: 800px;
  padding: 10px;
  margin-top: 8px;
  position: relative;
  .delete {
    position: absolute;
    top: 10px;
    right: 10px;
  }
}
.stage-title {
  font-size: 23px;
  font-weight: 400;
  margin-top: 5px;
}
.stage-group,
.stage-tag {
  margin-top: 5px;
  font-size: 18px;
}
.empty {
  margin-left: 200px;
}
</style>
